import { Action, Message } from "types/redux"

import {
  CONTACTLESS_PAYMENT_WAITING_STAFF_SUCCESS,
  CONTACTLESS_PAYMENT_CREATE_REQUEST,
  CONTACTLESS_PAYMENT_CREATE_SUCCESS,
  CONTACTLESS_PAYMENT_CREATE_ERROR,
  CONTACTLESS_PAYMENT_POLL_SUCCESS,
  CONTACTLESS_PAYMENT_POLL_ERROR,
  CONTACTLESS_PAYMENT_POLL_TIMEOUT,
  CONTACTLESS_PAYMENT_POLL_CANCEL,
  CONTACTLESS_PAYMENT_RESET,
  READER_LINK_QR_REQUEST,
  READER_LINK_QR_SUCCESS,
  READER_LINK_QR_ERROR,
  READER_CHECK_LINKED_REQUEST,
  READER_CHECK_LINKED_SUCCESS,
  READER_CHECK_LINKED_ERROR,
  READER_GET_DEVICE_MODELS_REQUEST,
  READER_GET_DEVICE_MODELS_SUCCESS,
  READER_GET_DEVICE_MODELS_ERROR,
  READER_GET_DEVICE_MODELS_POLL_SUCCESS,
  READER_DELETE_DEVICE_MODEL_REQUEST,
  READER_DELETE_DEVICE_MODEL_SUCCESS,
  READER_DELETE_DEVICE_MODEL_ERROR,
} from "./constants"

import {
  ContactlessPaymentCreateResponse,
  ReaderLinkQRResponse,
  ReaderCheckLinkedResponse,
  ReaderGetDeviceModelsResponse,
  DeviceModel,
} from "./actions"

export type ContactlessPaymentStatus = 
  | "waitingStaff"
  | "creating"
  | "polling"
  | "success"
  | "failed"
  | "timeout"
  | "cancelled"

export interface ContactlessPaymentState {
  status: ContactlessPaymentStatus
  payment_intent_id: string | null
  error: Message | null
  readerQR: {
    loading: boolean
    token: string | null
    duration: number | null
    error: Message | null
  }
  readerLinked: {
    loading: boolean
    readers_ids: Array<string>
    error: Message | null
  }
  deviceModels: {
    loading: boolean
    models: Array<DeviceModel>
    error: Message | null
  }
}

const initialState: ContactlessPaymentState = {
  status: "waitingStaff",
  payment_intent_id: null,
  error: null,
  readerQR: {
    loading: false,
    token: null,
    duration: null,
    error: null,
  },
  readerLinked: {
    loading: false,
    readers_ids: [],
    error: null,
  },
  deviceModels: {
    loading: false,
    models: [] as Array<DeviceModel>,
    error: null,
  },
}

export default function contactlessPaymentReducer(
  state = initialState,
  action: Action<any>
): ContactlessPaymentState {
  switch (action.type) {
    case CONTACTLESS_PAYMENT_WAITING_STAFF_SUCCESS:
      return {
        ...state,
        error: null,
      }
    case CONTACTLESS_PAYMENT_CREATE_REQUEST:
      return {
        ...state,
        status: "creating",
        error: null,
      }
    case CONTACTLESS_PAYMENT_CREATE_SUCCESS:
      return {
        ...state,
        status: "polling",
        payment_intent_id: (action.payload as ContactlessPaymentCreateResponse).payment_intent_id,
        error: null,
      }
    case CONTACTLESS_PAYMENT_CREATE_ERROR:
      return {
        ...state,
        status: "failed",
        error: action.payload as Message,
      }

    case CONTACTLESS_PAYMENT_POLL_SUCCESS:
      return {
        ...state,
        status: "success",
      }
    case CONTACTLESS_PAYMENT_POLL_ERROR:
      return {
        ...state,
        status: "failed",
        error: action.payload as Message,
      }
    case CONTACTLESS_PAYMENT_POLL_TIMEOUT:
      return {
        ...state,
        status: "timeout",
        error: { type: "error", text: "Délai dépassé" },
      }
    case CONTACTLESS_PAYMENT_POLL_CANCEL:
      return {
        ...state,
        status: "cancelled",
      }

    case CONTACTLESS_PAYMENT_RESET:
      return {
        ...initialState,
        readerLinked: {
          ...state.readerLinked
        },
      }

    case READER_LINK_QR_REQUEST:
      return {
        ...state,
        readerQR: {
          ...state.readerQR,
          duration: null,
          loading: true,
          error: null,
        },
      }
    case READER_LINK_QR_SUCCESS:
      return {
        ...state,
        readerQR: {
          loading: false,
          token: (action.payload as ReaderLinkQRResponse).token,
          duration: (action.payload as ReaderLinkQRResponse).duration,
          error: null,
        },
      }
    case READER_LINK_QR_ERROR:
      return {
        ...state,
        readerQR: {
          ...state.readerQR,
          duration: null,
          loading: false,
          error: action.payload as Message,
        },
      }

    case READER_CHECK_LINKED_REQUEST:
      return {
        ...state,
        readerLinked: {
          ...state.readerLinked,
          loading: true,
          error: null,
        },
      }
    case READER_CHECK_LINKED_SUCCESS:
      return {
        ...state,
        readerLinked: {
          loading: false,
          readers_ids: (action.payload as ReaderCheckLinkedResponse).readers_ids,
          error: null,
        },
      }
    case READER_CHECK_LINKED_ERROR:
      return {
        ...state,
        readerLinked: {
          ...state.readerLinked,
          loading: false,
          error: action.payload as Message,
        },
      }

    case READER_GET_DEVICE_MODELS_REQUEST:
      return {
        ...state,
        deviceModels: {
          ...state.deviceModels,
          loading: true,
          error: null,
        },
      }
    case READER_GET_DEVICE_MODELS_SUCCESS:
      return {
        ...state,
        deviceModels: {
          loading: false,
          models: action.payload as ReaderGetDeviceModelsResponse,
          error: null,
        },
      }
    case READER_GET_DEVICE_MODELS_ERROR:
      return {
        ...state,
        deviceModels: {
          ...state.deviceModels,
          loading: false,
          error: action.payload as Message,
        },
      }
      case READER_GET_DEVICE_MODELS_POLL_SUCCESS:
        return {
          ...state,
          deviceModels: {
            ...state.deviceModels,
            models: action.payload as ReaderGetDeviceModelsResponse,
            error: null,
          },
        }

    case READER_DELETE_DEVICE_MODEL_REQUEST:
      return {
        ...state,
        deviceModels: {
          ...state.deviceModels,
          loading: true,
          error: null,
        },
      }
    case READER_DELETE_DEVICE_MODEL_SUCCESS:
      return {
        ...state,
        deviceModels: {
          ...state.deviceModels,
          loading: false,
          error: null,
        },
      }
    case READER_DELETE_DEVICE_MODEL_ERROR:
      return {
        ...state,
        deviceModels: {
          ...state.deviceModels,
          loading: false,
          error: action.payload as Message,
        },
      }

    default:
      return state
  }
}

